import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import styled from 'styled-components';

export const QcConfigRow = styled(PocCard)`
    width: 100%;

    /* OWC-OVERRIDE: stack the QC config rows with the card's v6 padding. owc-card's content
       wrapper is a plain block with zero padding in v7.6.0 and exposes no layout or padding
       prop. */
    > .owc-card__content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        padding: 1rem;
    }

    owc-input,
    owc-select-dropdown {
        width: 100%;
    }
`;

export const QcConfigRowHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`;

export const QcTestFieldsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
`;

export const QcFieldLabel = styled.span`
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${owcTheme['one-color-gray-800']};
`;

export const QcConfigRangeMode = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    owc-toggle-button-group {
        width: 100%;
    }

    owc-toggle-button {
        flex: 1;
    }
`;

export const QcConfigLevels = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
